import { addSlideFooter } from '../slide_footer';
import { TITLE_TEXT } from '../constants';

/**
 * Creates a section divider slide (used to head each tab in an entire-report export).
 * @param {Object} pptx
 * @param {Array}  reportDateRange
 * @param {String} reportType
 * @param {String} reportUrl
 * @param {Object} shopperAttributes
 * @param {String} title
 * @returns {Object}
 */
export const createSectionSlide = ({
  pptx,
  reportDateRange,
  reportType,
  reportUrl,
  shopperAttributes,
  title,
}) => {
  const slide = pptx.addSlide();

  slide.addText(title || '', {
    ...TITLE_TEXT,
    align: 'center',
    fontSize: 32,
    h: '80%',
    valign: 'middle',
    w: '100%',
    x: 0,
    y: 0,
  });

  addSlideFooter({ pptx, reportDateRange, reportType, reportUrl, shopperAttributes, slide });

  return slide;
};
